import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";

import { Card } from "material-ui/Card";
import { CircularProgress, RaisedButton, TextField } from "material-ui";
import * as LoginActions from "../../../redux/action/login-action";
import { Constants } from "../../../constants";
import { DS } from "../../../theme-default";

class LoginPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: "",
      loginInProgress: false,
      errors: {}
    };
  }

  onEmailChange = e => {
    let newState = this.state;
    newState.email = e.target.value;
    this.setState(newState);
  };

  onPasswordChange = e => {
    let newState = this.state;
    newState.password = e.target.value;
    this.setState(newState);
  };

  componentDidMount() {
    //check user details
  }

  onLogin = () => {
    this.props.doLogin(this.state.email, this.state.password);
  };

  render() {
    return (
      <div style={{ padding: "0 16px" }}>
      <div className="ds-login-brand">
        <i className="material-icons">gavel</i>
        Achiziții Publice
      </div>
      <Card
        style={{
          textAlign: "center",
          padding: "24px 32px 40px",
          maxWidth: 420,
          margin: "0 auto",
          border: `1px solid ${DS.border}`,
          borderRadius: DS.radiusCard,
          boxShadow: "none"
        }}
      >
        {(this.props.loginSuccessful ||
          localStorage.getItem(Constants.STORAGE_JWT_TOKEN_KEY) !== null) && (
          <Redirect to={"/app"} />
        )}
        <h2
          className="card-heading"
          style={{ fontSize: 20, fontWeight: 600, color: DS.ink }}
        >
          Autentificare
        </h2>

        {this.props.loginInProgress ? (
          <div style={{ display: "inline-block", marginTop: "10px" }}>
            <CircularProgress />
          </div>
        ) : null}

        {this.props.errors.summary && (
          <div
            style={{
              fontSize: "12px",
              color: DS.error,
              marginTop: "5px"
            }}
          >
            {this.props.errors.summary}
          </div>
        )}

        <div className="field-line">
          <TextField
            floatingLabelText="Email"
            name="email"
            fullWidth
            errorText={this.props.errors.email}
            value={this.state.email}
            onChange={this.onEmailChange}
          />
        </div>

        <div className="field-line">
          <TextField
            floatingLabelText="Parola"
            type="password"
            name="password"
            fullWidth
            errorText={this.props.errors.password}
            value={this.state.password}
            onChange={this.onPasswordChange}
          />
        </div>

        <div className="button-line" style={{ marginTop: "32px" }}>
          <RaisedButton
            type="submit"
            label="Autentificare"
            primary
            fullWidth
            onClick={this.onLogin}
          />
        </div>
      </Card>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    loginInProgress: state.login.inProgress,
    loginSuccessful: state.login.successful,
    errors: state.login.errors
  };
}

function mapDispatchToProps(dispatch) {
  return {
    doLogin: (email, password) => dispatch(LoginActions.login(email, password))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginPage);
